import React from 'react';

import {REACTION_ICON_SIZES, REACTION_THUMBS_UP} from '../constants';

import Reaction from './reaction';

const PermanentReaction = ({
  onClick
}) => (
  <Reaction
    type={REACTION_THUMBS_UP}
    count="0"
    size={REACTION_ICON_SIZES.SMALL}
    onClick={onClick}
  />
);

export {PermanentReaction};
